export const Credits = () => (
  <div className="text-center">
    <p>
      Powered by{' '}
      <a
        href="https://sofi.coop/chatbot?utm_source=web"
        target="_blank"
        rel="noreferrer"
        className="text-secondary"
      >
        Sofia
      </a>
    </p>
  </div>
);
